import axios from "axios";

export const updateHireCustomerInvoice = (endpoint, job, invoiceNumber, workTrackingOption, workNominalCode, partTrackingOption, partNominalCode, invoiceDate, isQuote) => {
  // get existing job
  let url = endpoint + "jobs/" + job;
  if(isQuote){
    url = endpoint + "quotes/" + job
  }
  const conf = {
    method: "get",
    url
  };

  return axios(conf).then(resp => {
    // update invoice number
    let jobData = resp.data;
    jobData.customer2_invoice_number = invoiceNumber || jobData.customer2_invoice_number;
    jobData.customer2_invoice_date = invoiceDate || jobData.customer2_invoice_date;
    // lazy way to handle quotes not having the  property work_items
    if(!isQuote) {
      jobData.work_items = jobData.work_items.map(work_item => {
        let toSave = {...work_item};
        if (workTrackingOption) {
          toSave.customer_tracking_option = workTrackingOption
        }
        if (workNominalCode) {
          toSave.customer_nominal_code = workNominalCode
        }
        toSave.parts = work_item.parts.map(part => {
          let partToSave = {...part};
          if (partNominalCode) {
            partToSave.customer_nominal_code = partNominalCode;
          }
          if (partTrackingOption) {
            partToSave.customer_tracking_option = partTrackingOption;
          }
          return partToSave;
        });
        return toSave;
      });
    }
    const putConf = {
      method: "put",
      url,
      data: jobData
    };
    return axios(putConf);
  });
};

export const updateBothInvoices = (endpoint, job, invoiceNumber, workTrackingOption, workNominalCode, partTrackingOption, partNominalCode, invoiceDate) => {
  // get existing job
  const url = endpoint + "jobs/" + job;
  const conf = {
    method: "get",
    url
  };

  return axios(conf).then(resp => {
    // update invoice number
    let jobData = resp.data;
    jobData.customer1_invoice_date = invoiceDate || jobData.customer1_invoice_date;
    jobData.customer2_invoice_date = invoiceDate || jobData.customer2_invoice_date;
    jobData.customer2_invoice_number =
      invoiceNumber || jobData.customer2_invoice_number;
    jobData.customer_invoice_number =
      invoiceNumber || jobData.customer_invoice_number;
    jobData.work_items = jobData.work_items.map(work_item => {
      let toSave = { ...work_item };
      if(workTrackingOption){
        toSave.customer_tracking_option = workTrackingOption
      }
      if(workNominalCode){
        toSave.customer_nominal_code = workNominalCode
      }
      toSave.parts = work_item.parts.map(part => {
        let partToSave = { ...part };
        if(partNominalCode){
          partToSave.customer_nominal_code = partNominalCode;
        }
        if(partTrackingOption){
          partToSave.customer_tracking_option = partTrackingOption;
        }
        return partToSave;
      });
      return toSave;
    });
    const putConf = {
      method: "put",
      url,
      data: jobData
    };
    return axios(putConf);
  });
};

export const updateCustomerInvoice = (endpoint, job, invoiceNumber, workTrackingOption, workNominalCode, partTrackingOption, partNominalCode, invoiceDate, isQuote) => {
  // get existing job
  let url = endpoint + "jobs/" + job;
  if(isQuote){
    url = endpoint + "quotes/" + job
  }
  const conf = {
    method: "get",
    url
  };

  return axios(conf).then(resp => {
    // update invoice number
    let jobData = resp.data;
    jobData.customer_invoice_number = invoiceNumber || jobData.customer_invoice_number;
    jobData.customer1_invoice_date = invoiceDate || jobData.customer1_invoice_date;
    // lazy  way to handle quote not having property work item
    if(!isQuote) {
      jobData.work_items = jobData.work_items.map(work_item => {
        let toSave = {...work_item};
        if (workTrackingOption) {
          toSave.customer_tracking_option = workTrackingOption
        }
        if (workNominalCode) {
          toSave.customer_nominal_code = workNominalCode
        }
        toSave.parts = work_item.parts.map(part => {
          let partToSave = {...part};
          if (partNominalCode) {
            partToSave.customer_nominal_code = partNominalCode;
          }
          if (partTrackingOption) {
            partToSave.customer_tracking_option = partTrackingOption;
          }
          return partToSave;
        });
        return toSave;
      });
    }
    const putConf = {
      method: "put",
      url,
      data: jobData
    };
    return axios(putConf);
  });
};

export const updateWorkshopInvoice = (
  endpoint,
  job,
  invoiceNumber,
  paymentDate,
  invoice_date,
  creditNumber,
  trackingOption,
  nominalCode
) => {
  // get existing job
  const url = endpoint + "jobs/" + job;
  const conf = {
    method: "get",
    url
  };

  return axios(conf).then(resp => {
    // update invoice number
    let jobData = resp.data;
    jobData.workshop_invoice_number =
      invoiceNumber || jobData.workshop_invoice_number;

    jobData.workshop_invoice_payment_date =
      paymentDate === "" ? jobData.workshop_invoice_payment_date : paymentDate;

    jobData.workshop_invoice_date = invoice_date;

    jobData.workshop_credit_note_number = creditNumber || jobData.workshop_credit_note_number;

    jobData.work_items = resp.data.work_items.map(work_item => {
      let toSave = { ...work_item };
      if(trackingOption){
        toSave.supplier_tracking_option = trackingOption
      }
      if(nominalCode){
        toSave.supplier_nominal_code = nominalCode
      }
      toSave.parts = work_item.parts.map(part => {
        let partToSave = { ...part };
        if (part.supplier.id === jobData.workshop.id) {
          partToSave.part_invoice_number =
            invoiceNumber || partToSave.part_invoice_number;
        }
        return partToSave;
      });
      return toSave;
    });

    const putConf = {
      method: "put",
      url,
      data: jobData
    };
    return axios(putConf);
  });
};
